import api from '../api/api.js'

export default {
  namespaced: true,

  state: {
    // 画面遷移した際に選択した店舗IDを保持
    // 初期値は店舗ID「全て」
    selectedStoreId: '00000',

    store: {}
  },

  getters: {
    selectedStoreId(state) {
      return state.selectedStoreId
    },
    store(state) {
      return state.store
    }
  },

  mutations: {
    selectedStoreId(state, payload) {
      state.selectedStoreId = payload
    },
    store(state, payload) {
      state.store = payload
    },
    resetStore(state) {
      state.store = {}
    }
  },

  actions: {
    /**
     * 店舗一覧取得
     */
    getStore({ commit }, payload) {
      return api.get('/api/v2/store/get', {})
        .then((res) => {
          commit('store', res.data.store)
        })
    },

    /**
     * 選択した店舗IDを保存
     */
    setSelectedStoreId({ commit }, payload) {
      commit('selectedStoreId', payload)
    },

    /**
     * ログアウト時にstore一覧をリセットする
     */
    resetStore({ commit }) {
      commit('resetStore')
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/store.js